<template>
	<div
		class="c-hero__wrapper"
		:class="{
			dark: section.dark_mode,
			'no-bg':
				template.name === 'hero-4' ||
				template.name === 'hero-6' ||
				template.name === 'hero-7',
		}"
		v-bind:style="{
			'background-image': 'url(' + section.backgroundImage + ') ',
		}"
	>
		<div
			v-if="template.name === 'hero-2'"
			class="component c-hero c-hero--template-2 d-flex position-relative"
			:class="navigation_class"
		>
			<div
				class="c-hero__background d-flex flex-item-1 flex-direction-column position-relative"
				:class="navigation_class"
				v-bind:style="{
					'background-image': 'url(' + section.backgroundImage + ') ',
				}"
			>
				<div
					class="c-hero__ad position-relative flex-grow-0 flex-shrink-0"
				>
					<element-ad
						:key="'ad_footer'"
						name="signingday-repeated-1"
					/>
				</div>
				<div
					class="c-hero__content position-relative padding-y-24 flex-grow-1 flex-shrink-0 d-flex flex-direction-column justify-content-center align-items-center text-align-center"
				>
					<div
						class="c-hero__details line-height-100 padding-y-24 padding-x-24 bp-540:padding-x-48 bp-1024:padding-x-0 bp-1024:max-width-67"
					>
						<h2
							v-if="section.headline"
							class="c-hero__headline margin-0 padding-0 text-transform-uppercase font-size-21 bp-540:font-size-24 bp-768:font-size-36"
						>
							{{ section.headline }}
						</h2>
						<h3
							class="c-hero__sport padding-0 text-transform-uppercase font-size-48 bp-540:font-size-72 bp-768:font-size-96 border-t border-b  margin-y-12"
						>
							{{ $root.signing_day.sport.title }}
						</h3>
						<time
							class="font-size-14 bp-540:font-size-18 bp-768:font-size-21"
							v-if="section.includeSigningDate"
							:datetime="section.signOnDate"
							>{{
								moment(section.signOnDate).format(
									'dddd, MMMM Do, YYYY',
								)
							}}</time
						>
					</div>
					<div
						v-if="section.sponsor && section.sponsor.image"
						class="c-hero__sponsor"
					>
						<a
							:href="section.sponsor.url"
							v-if="section.sponsor.url"
						>
							<img
								:src="section.sponsor.image"
								:alt="section.headline + ' Sponsor'"
							/>
						</a>
						<img
							v-if="!section.sponsor.url"
							:src="section.sponsor.image"
							:alt="section.headline + ' Sponsor'"
						/>
					</div>
				</div>
			</div>
		</div>
		<div
			v-if="template.name === 'hero-1-committed'"
			class="component c-hero c-hero--template-1-committed c-hero--template-1 position-relative bp-1280:d-flex"
			:class="navigation_class"
		>
			<div class="c-hero__ad">
				<element-ad :key="'ad_footer'" name="signingday-repeated-1" />
			</div>
			<div
				class="c-hero__left"
				v-bind:style="{
					'background-image': 'url(' + section.backgroundImage + ') ',
				}"
			></div>
			<div class="c-hero__right">
				<div class="c-hero__info">
					<time
						class="c-hero__date margin-y-12 font-size-14 bp-768:font-size-21 font-weight-700 line-height-125 order-1 bp-786:order-0"
						v-if="section.includeSigningDate"
						:datetime="section.signOnDate"
						>{{
							moment(section.signOnDate).format(
								'dddd, MMMM D, YYYY',
							)
						}}</time
					>
					<div
						class="c-hero__details bp-768:margin-t-24 d-flex flex-direction-column bp-768:flex-direction-row order-2 bp-768:order-1"
					>
						<div class="c-hero__details--logo">
							<img
								:src="
									$root.signing_day &&
									$root.signing_day.schoolTeam &&
									$root.signing_day.schoolTeam.logo
										? $root.signing_day.schoolTeam.logo
										: '/images/logos/site/site.png'
								"
								alt="Hero Signing Day Logo"
							/>
						</div>
						<div class="c-hero__details--info">
							<div
								class="c-hero__details--subtitle margin-b-8 bp-768:margin-b-0 font-weight-700 font-size-18 bp-1024:font-size-21 line-height-125 text-transform-uppercase"
							>
								Welcome to
							</div>
							<div
								class="c-hero__details--title font-weight-900 text-transform-uppercase"
							>
								Signing Day
							</div>
							<div
								class="c-hero__details--cursive margin-t-40 bp-768:margin-t-0"
							>
								<div class="c-hero__details--cursive-x">
									<svg
										width="19"
										height="24"
										viewBox="0 0 19 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M17.604 24L9.468 12.264L1.188 24H0.432L9.108 11.688L1.188 0.239999H1.908L9.468 11.184L17.208 0.239999H18L9.864 11.76L18.324 24H17.604Z"
											fill="currentcolor"
										/>
									</svg>
								</div>
								<div
									class="c-hero__details--cursive-sign "
									style="margin-top:-20px;"
									v-if="ready_to_play"
								>
									<lottie
										:options="defaultOptionsCommitted"
									/>
								</div>
							</div>
						</div>
					</div>
					<div
						v-if="section.sponsor && section.sponsor.image"
						class="c-hero__sponsor order-0 bp-768:order-2"
					>
						<a
							:href="section.sponsor.url"
							v-if="section.sponsor.url"
						>
							<img
								:src="section.sponsor.image"
								:alt="section.headline + ' Sponsor'"
							/>
						</a>
						<img
							v-if="!section.sponsor.url"
							:src="section.sponsor.image"
							:alt="section.headline + ' Sponsor'"
						/>
					</div>
				</div>
				<swiper
					ref="mySwiper"
					:options="swiperOptions"
					class="c-justsigned__slider"
					v-if="roster_players.length > 0"
				>
					<swiper-slide
						class="c-justsigned__item"
						v-for="player in roster_players"
						:key="player.player_id"
					>
						<div
							class="c-justsigned__media"
							v-bind:style="{
								'background-image':
									'url(' +
									(player.image
										? player.image + '?width=500'
										: 'https://s3.amazonaws.com/assets.sidearmsports.com/common/images/card-default_light.jpg') +
									') ',
							}"
						></div>
						<div class="c-justsigned__details">
							<div
								class="c-justsigned__time font-size-14 line-height-150 text-transform-uppercase"
							>
								<span class="font-weight-bold margin-r-4"
									>JUST SIGNED</span
								><span>{{ player.signingtime }}</span>
							</div>
							<div
								class="c-justsigned__name font-weight-700 line-height-125 font-size-21"
							>
								<a
									v-bind:href="
										'/roster.aspx?rp_id=' + player.id
									"
									>{{ player.fullname }}</a
								>
							</div>
						</div>
					</swiper-slide>
				</swiper>
			</div>
		</div>
		<div
			v-if="template.name === 'hero-1'"
			class="component c-hero c-hero--template-1 c-hero--template-1-not-committed position-relative bp-1280:d-flex"
			:class="navigation_class"
		>
			<div class="c-hero__ad">
				<element-ad :key="'ad_footer'" name="signingday-repeated-1" />
			</div>
			<div
				class="c-hero__left"
				v-bind:style="{
					'background-image': 'url(' + section.backgroundImage + ') ',
				}"
			></div>
			<div class="c-hero__right">
				<div class="c-hero__info">
					<time
						class="c-hero__date margin-y-12 font-size-14 bp-768:font-size-21 font-weight-700 line-height-125 order-1 bp-768:order-0"
						v-if="section.includeSigningDate"
						:datetime="section.signOnDate"
						>{{
							moment(section.signOnDate).format(
								'dddd, MMMM D, YYYY',
							)
						}}</time
					>
					<div
						class="c-hero__details bp-768:margin-t-24 d-flex flex-direction-column bp-768:flex-direction-row order-2 bp-768:order-1"
					>
						<div class="c-hero__details--logo">
							<img
								:src="
									$root.signing_day &&
									$root.signing_day.schoolTeam &&
									$root.signing_day.schoolTeam.logo
										? $root.signing_day.schoolTeam.logo
										: '/images/logos/site/site.png'
								"
								alt="Hero Signing Day Logo"
							/>
						</div>
						<div class="c-hero__details--info">
							<div
								class="c-hero__details--subtitle margin-b-8 bp-768:margin-b-0 font-weight-700 font-size-18 bp-1024:font-size-21 line-height-125 text-transform-uppercase"
							>
								Welcome to
							</div>
							<div
								class="c-hero__details--title font-weight-900 text-transform-uppercase"
							>
								Signing Day
							</div>
							<div
								class="c-hero__details--cursive margin-t-40 bp-768:margin-t-0"
							>
								<div class="c-hero__details--cursive-x">
									<svg
										width="19"
										height="24"
										viewBox="0 0 19 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M17.604 24L9.468 12.264L1.188 24H0.432L9.108 11.688L1.188 0.239999H1.908L9.468 11.184L17.208 0.239999H18L9.864 11.76L18.324 24H17.604Z"
											fill="currentcolor"
										/>
									</svg>
								</div>
								<div
									class="c-hero__details--cursive-sign"
									v-if="ready_to_play"
								>
									<lottie :options="defaultOptionsSigned" />
								</div>
							</div>
						</div>
					</div>
					<div
						v-if="section.sponsor && section.sponsor.image"
						class="c-hero__sponsor order-0 bp-768:order-2"
					>
						<a
							:href="section.sponsor.url"
							v-if="section.sponsor.url"
						>
							<img
								:src="section.sponsor.image"
								:alt="section.headline + ' Sponsor'"
							/>
						</a>
						<img
							v-if="!section.sponsor.url"
							:src="section.sponsor.image"
							:alt="section.headline + ' Sponsor'"
						/>
					</div>
				</div>
				<swiper
					ref="mySwiper"
					:options="swiperOptions"
					class="c-justsigned__slider"
					v-if="roster_players.length > 0"
				>
					<swiper-slide
						class="c-justsigned__item"
						v-for="player in roster_players.sort((a, b) => {
							if (
								a.signingtime === null ||
								b.signingtime === null
							) {
								return 0;
							}

							return (
								Date.parse(
									'2021/01/01 ' +
										b.signingtime.slice(0, -2) +
										' ' +
										b.signingtime.slice(-2),
								) -
								Date.parse(
									'2021/01/01 ' +
										a.signingtime.slice(0, -2) +
										' ' +
										a.signingtime.slice(-2),
								)
							);
						})"
						:key="player.player_id"
					>
						<div
							class="c-justsigned__media"
							v-bind:style="{
								'background-image':
									'url(' +
									(player.image
										? player.image + '?width=100'
										: 'https://s3.amazonaws.com/assets.sidearmsports.com/common/images/card-default_light.jpg') +
									') ',
							}"
						></div>
						<div class="c-justsigned__details">
							<div
								class="c-justsigned__time font-size-14 line-height-150 text-transform-uppercase"
							>
								<span class="font-weight-bold margin-r-4"
									>JUST SIGNED</span
								><span>{{ player.signingtime }}</span>
							</div>
							<div
								class="c-justsigned__name font-weight-700 line-height-125 font-size-21"
							>
								<a
									v-bind:href="
										'/roster.aspx?rp_id=' + player.id
									"
									>{{ player.fullname }}</a
								>
							</div>
						</div>
					</swiper-slide>
				</swiper>
			</div>
		</div>
		<div
			v-if="template.name === 'hero-3'"
			class="component c-hero c-hero--template-3 position-relative bp-1280:d-flex bp-1280:flex-direction-column"
			:class="navigation_class"
		>
			<div class="c-hero__ad">
				<element-ad :key="'ad_footer'" name="signingday-repeated-1" />
			</div>
			<div
				class="c-hero__logo"
				v-if="
					$root.signing_day &&
						$root.signing_day.schoolTeam &&
						$root.signing_day.schoolTeam.logo
				"
			>
				<img
					:src="
						$root.signing_day &&
						$root.signing_day.schoolTeam &&
						$root.signing_day.schoolTeam.logo
							? $root.signing_day.schoolTeam.logo
							: '/images/logos/site/site.png'
					"
					alt="Hero Signing Day Logo"
				/>
			</div>
			<div class="c-hero__content">
				<h3
					v-if="section.subHeadline"
					class="c-hero__subheadline font-weight-400 margin-0 padding-0 text-transform-uppercase font-size-21 line-height-125"
				>
					{{ section.subHeadline }}
				</h3>
				<h2
					v-if="section.headline"
					class="c-hero__headline position-relative padding-0 font-weight-900 padding-b-24 text-transform-uppercase line-height-100 font-size-72 bp-768:font-size-96  margin-y-12"
				>
					{{ section.headline }}
				</h2>

				<time
					class="c-hero__date margin-y-12 font-size-14 bp-768:font-size-21 line-height-125 order-1 bp-786:order-0 d-block padding-t-24 bp-786:padding-t-32"
					v-if="section.includeSigningDate"
					:datetime="section.signOnDate"
					>{{
						moment(section.signOnDate).format('dddd, MMMM D, YYYY')
					}}</time
				>
				<div
					v-if="section.sponsor && section.sponsor.image"
					class="c-hero__sponsor order-0 bp-768:order-2"
				>
					<a :href="section.sponsor.url" v-if="section.sponsor.url">
						<img
							:src="section.sponsor.image"
							:alt="section.headline + ' Sponsor'"
						/>
					</a>
					<img
						v-if="!section.sponsor.url"
						:src="section.sponsor.image"
						:alt="section.headline + ' Sponsor'"
					/>
				</div>
				<div class="c-hero__links">
					<ul>
						<li
							v-for="(link, index) in section.links"
							:key="link.title + index"
						>
							<a
								target="_blank"
								class="font-size-14 line-height-125 font-weight-700"
								:href="link.url"
								v-html="link.title"
							></a>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div
			v-if="template.name === 'hero-4'"
			class="component c-hero c-hero--template-4 position-relative d-flex flex-direction-column"
			:class="navigation_class"
		>
			<div class="c-hero__ad">
				<element-ad :key="'ad_footer'" name="signingday-repeated-1" />
			</div>
			<div
				class="c-hero__logo"
				v-if="
					$root.signing_day &&
						$root.signing_day.schoolTeam &&
						$root.signing_day.schoolTeam.logo
				"
			>
				<img
					:src="
						$root.signing_day &&
						$root.signing_day.schoolTeam &&
						$root.signing_day.schoolTeam.logo
							? $root.signing_day.schoolTeam.logo
							: '/images/logos/site/site.png'
					"
					alt="Hero Signing Day Logo"
				/>
			</div>
			<div class="c-hero__inner padding-x-12">
				<div
					class="c-hero__content d-flex flex-direction-column justify-content-center align-items-center text-align-center width-100"
					v-bind:style="{
						'background-image':
							'url(' + section.backgroundImage + ') ',
					}"
				>
					<h3
						v-if="section.subHeadline"
						class="c-hero__subheadline font-weight-600 margin-0 padding-0 text-transform-uppercase font-size-21 line-height-125"
					>
						{{ section.subHeadline }}
					</h3>
					<h2
						v-if="section.headline"
						class="c-hero__headline padding-b-16 position-relative padding-0 font-weight-900 text-transform-uppercase line-height-100 margin-y-0"
					>
						{{ section.headline }}
					</h2>

					<time
						class="c-hero__date margin-y-0 margin-t-24 font-size-14 bp-768:font-size-21 font-weight-600 line-height-125  d-block "
						v-if="section.includeSigningDate"
						:datetime="section.signOnDate"
						>{{
							moment(section.signOnDate).format(
								'dddd, MMMM D, YYYY',
							)
						}}</time
					>
					<div
						v-if="section.sponsor && section.sponsor.image"
						class="c-hero__sponsor "
					>
						<a
							:href="section.sponsor.url"
							v-if="section.sponsor.url"
						>
							<img
								:src="section.sponsor.image"
								:alt="section.headline + ' Sponsor'"
							/>
						</a>
						<img
							v-if="!section.sponsor.url"
							:src="section.sponsor.image"
							:alt="section.headline + ' Sponsor'"
						/>
					</div>
				</div>
				<div class="c-hero__signees flex-shrink-0">
					<swiper
						ref="mySwiper"
						:options="swiperOptions2"
						class="c-justsigned__slider"
						v-if="roster_players.length > 0"
					>
						<swiper-slide
							class="c-justsigned__item"
							v-for="player in roster_players"
							:key="player.player_id"
						>
							<div class="c-justsigned__item-inside">
								<div
									class="c-justsigned__media"
									v-bind:style="{
										'background-image':
											'url(' +
											(player.image
												? player.image + '?width=460'
												: 'https://s3.amazonaws.com/assets.sidearmsports.com/common/images/card-default_light.jpg') +
											') ',
									}"
								></div>
								<div
									class="c-justsigned__details d-flex align-items-center"
								>
									<div class="c-justsigned__details-left">
										<div
											class="c-justsigned__name font-weight-700 line-height-125 font-size-18 bp-1280:font-size-21"
										>
											<a
												v-bind:href="
													'/roster.aspx?rp_id=' +
														player.id
												"
												><div
													class="utility-text-truncate "
												>
													{{ player.fullname }}
												</div></a
											>
										</div>
										<div
											class=" font-size-12 bp-1280:font-size-14 line-height-150 font-weight-300"
										>
											<div class="utility-text-truncate ">
												{{ player.hometown }}
											</div>
										</div>
									</div>
									<div
										class="c-justsigned__details-right font-size-21 bp-1280:font-size-26 line-height-150 font-weight-700  text-transform-uppercase"
									>
										{{ player.position_short }}
									</div>
								</div>
							</div>
						</swiper-slide>
					</swiper>
				</div>
				<div class="c-hero__arrows d-flex align-items-center">
					<div class="button-prev c-hero__arrow " slot="button-prev">
						<feather
							class="font-size-24 "
							size="24"
							stroke-width="1"
							type="chevron-left"
						></feather>
					</div>
					<span
						class="flex-item-1 font-size-10 line-height-150 font-weight-700 text-transform-uppercase"
						><span>Just Signed</span></span
					>
					<div class="button-next c-hero__arrow " slot="button-next">
						<feather
							class="font-size-24 "
							size="24"
							stroke-width="1"
							type="chevron-right"
						></feather>
					</div>
				</div>
			</div>
		</div>
		<div
			v-if="template.name === 'hero-5'"
			class="component c-hero c-hero--template-5 height-100 width-100 position-relative d-flex flex-direction-column"
			:class="navigation_class"
		>
			<div class="c-hero__ad">
				<element-ad :key="'ad_footer'" name="signingday-repeated-1" />
			</div>

			<div
				class="flex-item-1 d-flex align-items-center justify-content-center"
			>
				<div class="row d-flex flex-direction-column">
					<div class="c-hero__content text-align-center">
						<div
							class="c-hero__logo margin-b-24"
							v-if="
								$root.signing_day &&
									$root.signing_day.schoolTeam &&
									$root.signing_day.schoolTeam.logo
							"
						>
							<img
								:src="
									$root.signing_day &&
									$root.signing_day.schoolTeam &&
									$root.signing_day.schoolTeam.logo
										? $root.signing_day.schoolTeam.logo
										: '/images/logos/site/site.png?width=80'
								"
								alt="Hero Signing Day Logo"
							/>
						</div>
						<h3
							v-if="section.subHeadline"
							class="c-hero__subheadline font-weight-700 margin-0 padding-0 text-transform-uppercase font-size-21 line-height-125"
						>
							{{ section.subHeadline }}
						</h3>
						<h2
							v-if="section.headline"
							class="c-hero__headline position-relative padding-0 font-weight-900 padding-b-16 text-transform-uppercase line-height-100 font-size-72 bp-768:font-size-96  margin-0"
						>
							{{ section.headline }}
						</h2>

						<time
							class="c-hero__date margin-0 font-size-14 font-weight-700 bp-768:font-size-21 line-height-125 d-block padding-t-24 "
							v-if="section.includeSigningDate"
							:datetime="section.signOnDate"
							>{{
								moment(section.signOnDate).format(
									'dddd, MMMM D, YYYY',
								)
							}}</time
						>
						<div
							v-if="section.sponsor && section.sponsor.image"
							class="c-hero__sponsor "
						>
							<a
								:href="section.sponsor.url"
								v-if="section.sponsor.url"
							>
								<img
									:src="section.sponsor.image"
									:alt="section.headline + ' Sponsor'"
								/>
							</a>
							<img
								v-if="!section.sponsor.url"
								:src="section.sponsor.image"
								:alt="section.headline + ' Sponsor'"
							/>
						</div>
					</div>
					<div class="c-hero__links">
						<ul>
							<li
								v-for="(link, index) in section.links"
								:key="link.title + index"
							>
								<a
									target="_blank"
									class="font-size-14 line-height-125 font-weight-700"
									:href="link.url"
									v-html="link.title"
								></a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div
			v-if="template.name === 'hero-6'"
			class="component c-hero c-hero--template-6 height-100 width-100 position-relative d-flex flex-direction-column"
			:class="navigation_class"
		>
			<div class="c-hero__ad">
				<element-ad :key="'ad_footer'" name="signingday-repeated-1" />
			</div>

			<div class="flex-item-1 position-relative d-block bp-1024:d-flex">
				<div class="flex-item-1 d-flex flex-direction-column  ">
					<div
						class="c-hero__content d-flex flex-direction-column justify-content-center"
					>
						<div
							class="c-hero__logo margin-b-24"
							v-if="
								$root.signing_day &&
									$root.signing_day.schoolTeam &&
									$root.signing_day.schoolTeam.logo
							"
						>
							<img
								:src="
									$root.signing_day &&
									$root.signing_day.schoolTeam &&
									$root.signing_day.schoolTeam.logo
										? $root.signing_day.schoolTeam.logo
										: '/images/logos/site/site.png?width=80'
								"
								alt="Hero Signing Day Logo"
							/>
						</div>
						<h3
							v-if="section.subHeadline"
							class="c-hero__subheadline font-weight-700 margin-0 padding-b-6 text-transform-uppercase font-size-21 line-height-125"
						>
							{{ section.subHeadline }}
						</h3>
						<h2
							v-if="section.headline"
							class="c-hero__headline position-relative padding-0 font-weight-900 padding-b-16 text-transform-uppercase line-height-100 font-size-72 bp-768:font-size-96  margin-0"
						>
							{{ section.headline }}
						</h2>

						<time
							class="c-hero__date margin-0 font-size-14 font-weight-400 bp-768:font-size-21 line-height-125 d-block padding-t-12 bp-1024:padding-t-24 "
							v-if="section.includeSigningDate"
							:datetime="section.signOnDate"
							>{{
								moment(section.signOnDate).format(
									'dddd, MMMM D, YYYY',
								)
							}}</time
						>
						<div
							v-if="section.sponsor && section.sponsor.image"
							class="c-hero__sponsor "
						>
							<a
								:href="section.sponsor.url"
								v-if="section.sponsor.url"
							>
								<img
									:src="section.sponsor.image"
									:alt="section.headline + ' Sponsor'"
								/>
							</a>
							<img
								v-if="!section.sponsor.url"
								:src="section.sponsor.image"
								:alt="section.headline + ' Sponsor'"
							/>
						</div>
						<div class="c-hero__links">
							<ul>
								<li
									v-for="(link, index) in section.links"
									:key="link.title + index"
								>
									<a
										target="_blank"
										class="font-size-14 line-height-125 font-weight-700"
										:href="link.url"
										v-html="link.title"
									></a>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div
					class="c-justsigned__slider-container"
					v-if="roster_players.length > 0"
				>
					<div class="c-justsigned__slider-wrapper">
						<div class="c-justsigned__slider">
							<swiper
								ref="mySwiper"
								:options="swiperOptions3"
								class="c-justsigned__slider-inside"
								v-if="roster_players.length > 0"
							>
								<swiper-slide
									class="c-justsigned__item"
									v-for="player in roster_players"
									:key="player.player_id"
								>
									<div
										class="c-justsigned__media"
										v-bind:style="{
											background:
												'linear-gradient(180deg, rgba(0, 0, 0, 0) 66.04%, rgba(0, 0, 0, 0.9) 100%),url(' +
												(player.image
													? player.image +
													  '?width=1000'
													: 'https://s3.amazonaws.com/assets.sidearmsports.com/common/images/card-default_light.jpg') +
												') top center / cover  no-repeat ',
										}"
									></div>
									<div class="c-justsigned__details">
										<div
											v-if="player.hometown"
											class=" font-size-12 bp-1280:font-size-14 line-height-150 font-weight-300"
										>
											<div class="utility-text-truncate ">
												{{ player.hometown }}
												<span
													v-if="player.position_short"
													>-
													<span
														class="font-weight-700"
													>
														{{
															player.position_short
														}}</span
													>
												</span>
											</div>
										</div>
										<div
											class="c-justsigned__name  font-weight-700 line-height-125 font-size-21"
										>
											<a
												v-bind:href="
													'/roster.aspx?rp_id=' +
														player.id
												"
												>{{ player.fullname }}</a
											>
										</div>
									</div>
								</swiper-slide>
							</swiper>
						</div>
						<div class="c-justsigned__arrows">
							<div class="c-justsigned__arrows-container">
								<div
									class="button-prev2 c-hero__arrow "
									slot="button-prev"
								>
									<feather
										class="font-size-24 "
										size="24"
										stroke-width="1"
										type="chevron-up"
									></feather>
								</div>
								<span
									class="flex-item-1 font-size-10 line-height-150 font-weight-700 text-transform-uppercase"
									><span>Just Signed</span></span
								>
								<div
									class="button-next2 c-hero__arrow "
									slot="button-next"
								>
									<feather
										class="font-size-24 "
										size="24"
										stroke-width="1"
										type="chevron-down"
									></feather>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div
			v-if="template.name === 'hero-7'"
			class="component c-hero c-hero--template-7 position-relative flex-direction-column d-flex bp-768:flex-direction-row "
			:class="navigation_class"
		>
			<div class="c-hero__ad">
				<element-ad :key="'ad_footer'" name="signingday-repeated-1" />
			</div>
			<div class="c-hero__content d-flex align-items-center">
				<div class="c-hero__content-inside ">
					<h2
						ref="el3"
						v-if="section.headline"
						class="c-hero__headline d-none bp-768:d-flex padding-b-16 position-relative padding-0 font-weight-900 text-transform-uppercase line-height-100 margin-y-0"
					>
						{{ section.headline }}
					</h2>
					<h3
						v-if="section.subHeadline"
						class="c-hero__subheadline d-none bp-768:d-block font-weight-600 margin-b-12 padding-0 text-transform-uppercase font-size-21 line-height-125"
					>
						{{ section.subHeadline }}
					</h3>
					<div
						v-if="section.subHeadline"
						class="c-hero__mobile d-block bp-768:d-none font-weight-600 margin-b-12 padding-0 text-transform-uppercase font-size-21 line-height-125"
					>
						<h2
							ref="el"
							v-if="section.headline"
							class="c-hero__headline  padding-b-16 position-relative padding-0 font-weight-900 text-transform-uppercase line-height-100 margin-y-0"
						>
							{{ section.headline }}
						</h2>
						<h3
							ref="el2"
							v-if="section.subHeadline"
							class="c-hero__subheadline  font-weight-600 margin-0 padding-0 text-transform-uppercase font-size-21 line-height-125"
						>
							{{ section.subHeadline }}
						</h3>
					</div>
					<time
						class="c-hero__date margin-y-0 margin-t-12 font-size-14 bp-768:font-size-21 font-weight-400 line-height-125  d-block "
						v-if="section.includeSigningDate"
						:datetime="section.signOnDate"
						>{{
							moment(section.signOnDate).format(
								'dddd, MMMM D, YYYY',
							)
						}}</time
					>
					<div
						v-if="section.sponsor && section.sponsor.image"
						class="c-hero__sponsor "
					>
						<a
							:href="section.sponsor.url"
							v-if="section.sponsor.url"
						>
							<img
								:src="section.sponsor.image"
								:alt="section.headline + ' Sponsor'"
							/>
						</a>
						<img
							v-if="!section.sponsor.url"
							:src="section.sponsor.image"
							:alt="section.headline + ' Sponsor'"
						/>
					</div>
				</div>
			</div>
			<div
				v-if="selectedPlayer"
				class="c-hero__signees d-flex flex-shrink-0"
			>
				<div
					class="c-hero__signee flex-item-1"
					v-bind:style="{
						backgroundImage:
							'url(' +
							(selectedPlayer.image
								? selectedPlayer.image + '?width=1000'
								: 'https://s3.amazonaws.com/assets.sidearmsports.com/common/images/card-default_light.jpg') +
							') ',
					}"
				>
					<div class="c-hero__signee-details">
						<div
							class="c-hero__signee-signed text-transform-uppercase font-size-10 line-height-150 font-weight-700"
						>
							Just Signed
						</div>
						<div
							class="c-hero__signee-name font-size-30 line-height-150 font-weight-300 "
						>
							{{ selectedPlayer.fullname }}
						</div>
						<div
							class="c-hero__signee-hometown font-size-12 line-height-150 font-weight-300"
						>
							{{ selectedPlayer.hometown }}
							<span class="font-weight-700"
								>- {{ selectedPlayer.position_short }}</span
							>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { hex2rgba, Lettering } from '@/helpers';
import SectionBase from './SectionBase';
import * as animationSignedData from '@/assets/animationSigned.json';
import * as animationCommittedData from '@/assets/animationCommitted.json';
import lottie from '@/components/elements/Lottie.vue';
export default {
	extends: SectionBase,
	name: 'SectionHero',
	components: {
		lottie,
	},
	data: () => ({
		swiperOptions: {
			effect: 'fade',
			autoplay: {
				delay: 10000,
				disableOnInteraction: false,
			},
		},
		swiperOptions2: {
			effect: 'fade',
			slidesPerView: 3,
			navigation: {
				nextEl: '.button-next',
				prevEl: '.button-prev',
			},
			autoplay: {
				delay: 10000,
				disableOnInteraction: false,
			},
			breakpoints: {
				1280: {
					slidesPerView: 4,
				},
				1025: {
					slidesPerView: 3,
				},
				540: {
					slidesPerView: 2,
				},
				0: {
					slidesPerView: 1,
				},
			},
		},
		swiperOptions3: {
			effect: 'fade',
			fadeEffect: { crossFade: true },
			slidesPerView: 1,
			navigation: {
				nextEl: '.button-next2',
				prevEl: '.button-prev2',
			},
			autoplay: {
				delay: 10000,
				disableOnInteraction: false,
			},
		},
		swiperOptions4: {
			effect: 'fade',
			fadeEffect: { crossFade: true },
			slidesPerView: 1,
			autoplay: {
				delay: 10000,
				disableOnInteraction: false,
			},
		},
		ready_to_play: false,
		defaultOptionsSigned: {
			animationData: animationSignedData.default,
			loop: false,
			rendererSettings: {
				progressiveLoad: true,
			},
		},
		defaultOptionsCommitted: {
			animationData: animationCommittedData.default,
			loop: false,
			rendererSettings: {
				progressiveLoad: true,
			},
		},
		selectedPlayer: null,
	}),
	methods: {},
	computed: {
		navigation_class() {
			if (this.$root.navigation) {
				let _template = this.$root.navigation.templates.find(
					template => {
						return template.selected;
					},
				);

				if (_template.name === 'nav-1') {
					return 'navigation-top';
				} else {
					return 'navigation-right';
				}
			}
			return '';
		},
		roster_players() {
			let _roster = this.$root.roster.slice();
			return _roster.reverse();
		},
	},
	created() {
		var hex = this.$root.signing_day.colors.primary_background;
		document.documentElement.style.setProperty(
			'--color-primary-rgba1',
			hex2rgba(hex, 0),
		);
		document.documentElement.style.setProperty(
			'--color-primary-rgba2',
			hex2rgba(hex, 0.2),
		);
		this.selectedPlayer = this.roster_players[
			this.roster_players.length - 1
		];
	},
	mounted() {
		if (this.$refs.el) {
			Lettering(this.$refs.el, {
				split: function(string) {
					return string.split(/(\s+)/);
				},
			});
		}
		if (this.$refs.el2) {
			Lettering(this.$refs.el2, {
				split: function(string) {
					return string.split(/(\s+)/);
				},
			});
		}
		if (this.$refs.el3) {
			Lettering(this.$refs.el3, {
				split: function(string) {
					return string.split(/(\s+)/);
				},
			});
		}

		setTimeout(() => {
			this.ready_to_play = true;
		}, 100);
	},
};
</script>

<style scoped lang="scss">
.c-hero {
	&__wrapper {
		background-position: top center;
		background-size: cover;
		&.no-bg {
			background: none !important;
		}
	}
}
.c-hero--template-1 {
	height: 100vh;
	background: #fff;
	.c-justsigned {
		&__item {
			font-family: 'Roboto Condensed', sans-serif;
			min-height: 100px;
			display: flex;
			color: $main-font-color;
		}
		&__time {
			padding: 0 24px;
			border-left: 2px solid $color-primary;
		}
		&__name {
			margin: 6px 0 0 0;
			padding: 0 24px;

			font-family: 'Work Sans', sans-serif;
			a {
				display: block;
				white-space: nowrap;
				text-overflow: ellipsis;
				overflow: hidden;
				text-decoration: none;
				&:hover {
					text-decoration: underline;
				}
			}
		}
		&__details {
			padding: 24px 0;
			flex: 1;
			overflow: hidden;
			border-left: 1px solid $main-border-color;
		}
		&__media {
			flex-shrink: 0;
			width: 100px;
			background-color: #fff;
			background-size: cover;
			background-position: top center;
		}
		&__slider {
			width: 420px;
			position: absolute;
			right: 24px;
			bottom: 24px;
			z-index: 2;
			margin: auto 0 0 0;
			background: $main-color;
			border: 1px solid $main-border-color;
			box-sizing: border-box;
		}
		@media screen and (max-width: 540px) {
			&__slider {
				bottom: auto;
				right: auto;
				position: relative;
				width: auto;
				justify-self: flex-end;
			}
			&__media {
				width: 80px;
			}
			&__item {
				min-height: 80px;
			}
			&__details {
				padding: 12px 0;
				display: flex;
				flex-direction: column;
				justify-content: center;
			}
			&__name {
				margin: 4px 0 0 0;
				padding: 0 12px;
			}
			&__time {
				padding: 0 12px;
			}
		}
	}
	&.navigation-top {
		height: calc(100vh - 100px);
	}
	@media screen and (max-width: 1023px) {
		height: calc(100vh - 60px);
		&.navigation-top {
			height: calc(100vh - 60px);
		}
	}
	@media screen and (max-width: 767px) {
		display: flex;
		flex-direction: column;
	}
	.c-hero {
		&__ad {
			z-index: 2;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			.sidearm-ad {
				border: none;
				background: none;
			}
		}
		&__left {
			flex: 0 2 59.34065%;
			background-color: $main-color;
			background-size: cover;
			background-position: top center;
		}
		&__right {
			padding: 48px;
			position: relative;
			flex: 0 1 40.65935%;
			background: $main-color;
		}
		&__date {
			color: $main-font-color;
			margin: 0 0 36px 0;
		}
		&__sponsor {
			margin: 48px 0 0 0;
			max-width: 150px;
		}
		&__info {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: flex-end;
			flex-shrink: 0;
			position: absolute;
			right: 48px;
			top: 50%;
			transform: translateY(-50%);
			z-index: 10;
		}
		&__details {
			background: $main-font-color;
			color: $main-color;
			&--info {
				padding: 24px 24px 12px 24px;
				flex: 1 1 auto;
				min-height: 1px;
				min-width: 1px;
			}
			&--cursive {
				padding: 0 12px;
				display: flex;
				align-items: center;
				height: 45px;
				border-bottom: 1px solid $main-color;
				svg path {
					color: $main-color;
				}
				&-sign {
					max-width: 450px;
				}
			}
			&--title {
				font-size: 120px;
				white-space: nowrap;
				line-height: 125%;
			}
			&--logo {
				display: flex;
				align-items: center;
				justify-content: center;
				flex-shrink: 0 0 auto;
				width: 257px;
				padding: 12px 24px;
				background: var(--color-primary);
				img {
					max-height: 100%;
				}
			}
		}
		@media screen and (max-width: 1279px) {
			&__ad {
				position: relative;
			}
			&__left {
				position: absolute;
				bottom: 0;
				left: 0;
				width: 60%;
				height: 100%;
			}
			&__right {
				background: none;
				position: static;
			}
			&__date {
				background: $main-color;
			}
			&__info {
				position: relative;
				right: auto;
				top: auto;
				transform: none;
			}
			&__details {
				&--logo {
					width: 204px;
				}
				&--cursive-sign {
					max-width: 350px;
				}
				&--title {
					font-size: 72px;
				}
			}
		}
		@media screen and (max-width: 1023px) {
			height: auto;
			min-height: calc(100vh - 60px);
			&.navigation-top {
				height: auto;
			}
			&__date {
				background: none;
			}
			&__details {
				&--logo {
					width: 256px;
				}
				&--title {
					white-space: initial;
					line-height: 1;
				}
			}
		}
		@media screen and (max-width: 767px) {
			&__info {
				align-items: stretch;
				padding: 0 24px;
			}
			&__date {
				text-align: center;
			}
			&__right {
				padding-left: 12px;
				padding-right: 12px;
				padding-top: 0;
				padding-bottom: 24px;
				flex: 1;
				display: flex;
				flex-direction: column;
			}
			&__left {
				width: 100%;
				height: 50%;
			}
			&__details {
				&--logo {
					width: 100%;
					height: 100px;
				}
				&--title {
					font-size: 54px;
				}
				&--info {
					padding: 12px;
				}
			}
			&__sponsor {
				margin: 48px auto 0;
			}
		}
	}
}

.c-hero--template-2 {
	height: 100vh;
	&.navigation-top {
		height: calc(100vh - 100px);
	}
	.c-hero {
		&__background {
			min-height: 100vh;
			background: top center no-repeat $main-color;
			background-size: cover;
			&::before {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				content: '';
				background: $main-color;
				opacity: 0.7;
			}
			&.navigation-top {
				min-height: calc(100vh - 100px);
			}
		}
		&__ad {
			.sidearm-ad {
				border: none;
				background: none;
			}
		}
		&__details {
			color: $main-font-color;
		}
		&__sport {
			border-color: $color-primary;
		}
		&__sponsor {
			max-width: 150px;
		}
		@media screen and (max-width: 1023px) {
			&__background {
				min-height: calc(100vh - 60px);
				&.navigation-top {
					min-height: calc(100vh - 60px);
				}
			}
		}
	}
}
.c-hero--template-3 {
	min-height: 100vh;
	&::before {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		content: '';
		background: $main-color;
		opacity: 0.2;
		z-index: 2;
	}
	&.navigation-top {
		min-height: calc(100vh - 100px);
	}
	@media screen and (max-width: 1023px) {
		min-height: calc(100vh - 60px);
		&.navigation-top {
			min-height: calc(100vh - 60px);
		}
	}
	.c-hero {
		&__logo {
			display: flex;
			align-items: center;
			justify-content: center;
			padding-top: 48px;
			img {
				max-width: 100px;
			}
			@media screen and (max-width: 1023px) {
				padding-top: 12px;
				img {
					max-width: 50px;
				}
			}
		}
		&__content {
			flex: 1;
			padding: 135px 120px 48px 120px;
			color: $main-font-color;
			position: relative;
			z-index: 2;
			@media screen and (max-width: 1023px) {
				padding: 135px 48px 48px 48px;
			}
			@media screen and (max-width: 768px) {
				padding: 135px 24px 48px 24px;
			}
		}
		&__sponsor {
			max-width: 150px;
			margin-top: 24px;
		}
		&__links {
			ul {
				margin: 48px 0 0 0;
				list-style: none;
				padding: 0;
				display: flex;
				flex-wrap: wrap;
				li {
					margin-right: 24px;
					a {
						display: block;
						text-decoration: none;
						padding: 15px 24px;
						background: $color_primary;
						color: $text_on_primary;
						transition: 0.25s;
						&:hover {
							transition: 0.25s;
							background: $color_secondary;
							color: $text_on_secondary;
						}
					}
				}
			}
		}
		&__headline {
			&:after {
				content: '';
				display: block;
				height: 1px;
				width: 100%;
				max-width: 350px;
				position: absolute;
				bottom: 0;
				left: 0;
				background: $color_primary;
			}
		}
	}
}
.c-hero--template-4 {
	background: $main-color;
	padding-bottom: 48px;
	min-height: 100vh;
	&.navigation-top {
		min-height: calc(100vh - 100px);
	}
	@media screen and (max-width: 1023px) {
		min-height: calc(100vh - 60px);
		&.navigation-top {
			min-height: calc(100vh - 60px);
		}
	}
	.c-justsigned {
		&__slider {
			margin: 0 -12px;
		}
		&__item {
			padding: 0 12px;
			&-inside {
				color: $main-font-color;
				background: $main-color;
				border: 1px solid $main-border-color;
				border-radius: 10px;
				overflow: hidden;
				height: 350px;
				display: flex;
				flex-direction: column;
				@media screen and (max-width: 767px) {
					height: auto;
					aspect-ratio: 1;
				}
			}
		}
		&__details {
			padding: 24px;
			@media screen and (max-width: 767px) {
				padding: 12px;
			}
			a {
				text-decoration: none;
				&:hover {
					text-decoration: underline;
				}
			}
			&-left {
				flex: 1;
				display: flex;
				flex-direction: column;
				overflow: hidden;
			}
			&-right {
				margin-left: 24px;
				color: $main-font-color;
			}
		}
		&__media {
			flex: 1;
			background-size: cover;
			background-position: top center;
			background-repeat: no-repeat;
		}
	}
	.c-hero {
		&__inner {
			display: grid;
			grid-template-rows: 1fr auto auto;
			width: 100%;
			min-height: 0;
			flex: 1;
			max-width: 1440px;
			margin-left: auto;
			margin-right: auto;
		}
		&__arrow {
			height: 24px;
			cursor: pointer;
			width: 24px;
			transition: 0.25s;
			&:hover {
				transition: 0.25s;
				background: $color-primary;
				color: $text-on-primary;
				svg {
					color: $color-safe-text-on-light;
					fill: $color-safe-text-on-light;
				}
			}
			&:first-child {
				margin-right: 24px;
			}
			&:last-child {
				margin-left: 24px;
			}
		}
		&__arrows {
			margin-top: 24px;
			color: $main-font-color;
			span {
				font-family: 'Roboto Condensed', sans-serif;
				display: flex;
				align-items: center;
				> span {
					margin: 0 24px;
				}
				&:before,
				&:after {
					content: '';
					display: block;
					flex: 1;
					height: 1px;
					background: $main-border-color;
				}
			}
		}
		&__subheadline {
			@media screen and (max-width: 1279px) {
				font-size: 18px;
			}
			@media screen and (max-width: 767px) {
				font-size: 14px;
				margin-bottom: 12px !important;
			}
		}
		&__headline {
			border-bottom: 2px solid #e2e2e2;
			font-size: 120px;
			@media screen and (max-width: 1279px) {
				font-size: 96px;
			}
			@media screen and (max-width: 767px) {
				font-size: 48px;
			}
		}
		&__sponsor {
			max-width: 150px;
			margin: 24px auto 0 auto;
		}
		&__signees {
			width: 100%;
			overflow: hidden;
		}
		&__content {
			border-radius: 10px;
			overflow: hidden;
			margin-top: 32px;
			margin-bottom: 24px;
			padding: 48px 24px;
			min-height: 300px;
			color: #fff;
			background-size: cover;
			background-position: top center;
			background-repeat: no-repeat;
			@media screen and (max-width: 1023px) {
				margin-top: 12px;
				margin-bottom: 12px;
			}
		}
		&__logo {
			display: flex;
			align-items: center;
			justify-content: center;
			padding-top: 48px;
			img {
				max-width: 100px;
			}
			@media screen and (max-width: 1023px) {
				padding-top: 12px;
				img {
					max-width: 50px;
				}
			}
		}
	}
}
.c-hero--template-5 {
	min-height: 100vh;
	padding: 24px;
	@media screen and (max-width: 767px) {
		padding: 12px;
	}
	.dfp-ad {
		margin: 0 auto 24px auto;
	}
	&.navigation-top {
		min-height: calc(100vh - 100px);
	}
	@media screen and (max-width: 1023px) {
		min-height: calc(100vh - 60px);
		&.navigation-top {
			min-height: calc(100vh - 60px);
		}
	}
	.c-hero {
		&__content {
			background: rgba(0, 0, 0, 0.2);
			border-radius: 10px;
			padding: 48px;
			color: #fff;
			@media screen and (max-width: 767px) {
				padding: 24px 12px;
			}
		}
		&__subheadline {
			@media screen and (max-width: 1279px) {
				font-size: 18px;
			}
			@media screen and (max-width: 767px) {
				font-size: 14px;
			}
		}
		&__headline {
			padding: 0 12px 16px 12px !important;
			border-bottom: 2px solid #e2e2e2;
			font-size: 120px;
			@media screen and (max-width: 1279px) {
				font-size: 96px;
			}
			@media screen and (max-width: 767px) {
				font-size: 64px;
			}
		}
		&__logo {
			img {
				max-width: 80px;
			}
		}
		&__sponsor {
			max-width: 150px;
			margin: 24px auto 0 auto;
		}
		&__links {
			ul {
				margin: 24px 0 0 0;
				list-style: none;
				padding: 0;
				display: flex;
				flex-wrap: wrap;
				justify-content: center;
				li {
					margin-right: 24px;
					a {
						display: block;
						text-decoration: none;
						padding: 15px 24px;
						border-radius: 100px;
						background: $color_primary;
						color: $text_on_primary;
						transition: 0.25s;
						&:hover {
							transition: 0.25s;
							background: $color_secondary;
							color: $text_on_secondary;
						}
					}
				}
			}
		}
	}
}
.c-hero--template-6 {
	min-height: 100vh;
	overflow: hidden;
	@media screen and (max-width: 1023px) {
		min-height: 1px;
	}
	.sidearm-ad {
		position: relative;
		z-index: 2;
		@media screen and (max-width: 1023px) {
			background: $color-primary;
		}
	}
	&:before {
		width: 68.125%;
		height: 100%;
		position: absolute;
		content: '';
		z-index: 1;
		box-shadow: 4px 4px 50px rgba(0, 0, 0, 0.25);
		display: block;
		background: $color-primary;
	}
	@media screen and (max-width: 1023px) {
		&:before {
			content: none;
			width: 100%;
		}
	}
	.c-justsigned {
		&__media {
			filter: drop-shadow(4px -4px 50px rgba(0, 0, 0, 0.25));
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-size: cover;
			background-position: top center;
		}
		&__item {
			position: relative;
		}
		&__details {
			position: absolute;
			bottom: 0;
			right: 0;
			width: 100%;
			padding: 32px 24px;
			z-index: 2;
		}
		&__arrows {
			width: 91.2280701754386%;
			height: 94.32703003337041%;
			position: absolute;
			top: 0;
			right: 0;
			margin: 0;
			background: #fafafa;
			box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25);
			&-container {
				height: 100%;
				width: 20.74175824175824%;
				position: absolute;
				top: 0;
				right: 0;
				display: flex;
				flex-direction: column;
				align-items: center;
				padding: 36px 0;
				color: $main-font-color;
				> span {
					font-family: 'Roboto Condensed', sans-serif;
					display: flex;
					align-items: center;
					flex-direction: column;
					&:before,
					&:after {
						content: '';
						display: block;
						flex: 1;
						width: 1px;
						margin: 0;
						background: $main-border-color;
					}
					&:before {
						margin: 0 0 36px 0;
					}
					&:after {
						margin: 36px 0 0 0;
					}
					> span {
						display: block;
						flex-shink: 0;
						white-space: nowrap;
						margin: 0 24px;
						-webkit-transform: rotate(-90deg);
					}
				}
			}
		}
		&__name {
		}
		&__slider {
			height: 95.66184649610679%;
			width: 81.03015075376884%;
			position: absolute;
			bottom: 0;
			left: 0;
			margin: 0;
			background: $main-color;
			&-inside {
				height: 100%;
				width: 100%;
				color: #fff;
				a {
					color: #fff;
					text-decoration: none;
					&:hover {
						text-decoration: underline;
					}
				}
			}
			&-wrapper {
				position: relative;
				height: 94.93136219640971%;
				width: 100%;
				z-index: 3;
			}
			&-container {
				width: 43.84615384615385%;
				@media screen and (max-width: 1023px) {
					width: 100%;
					aspect-ratio: 1;
					margin-top: -48px;
					position: relative;
					z-index: 5;
				}
			}
		}
	}
	.c-hero {
		&__sponsor {
			max-width: 150px;
			margin: 24px 0 0 0;
		}
		&__links {
			ul {
				margin: 12px 0 0 0;
				list-style: none;
				padding: 0;
				display: flex;
				flex-wrap: wrap;
				li {
					margin-top: 12px;
					margin-right: 24px;
					a {
						display: block;
						text-decoration: none;
						padding: 15px 24px;
						border-radius: 100px;
						background: $text_on_primary;
						color: $color_primary;
						transition: 0.25s;
						&:hover {
							transition: 0.25s;
							background: $color_secondary;
							color: $text_on_secondary;
						}
					}
				}
			}
		}
		&__arrow {
			height: 24px;
			cursor: pointer;
			width: 24px;
			transition: 0.25s;
			margin: 24px 0;
			&:hover {
				transition: 0.25s;
				background: $color-primary;
				color: $text-on-primary;
				svg {
					color: $color-safe-text-on-light;
					fill: $color-safe-text-on-light;
				}
			}
		}
		&__logo {
			img {
				max-width: 80px;
			}
		}
		&__content {
			color: $text-on-primary;
			position: relative;
			z-index: 4;
			padding-left: 12%;
			padding-right: 12%;
			flex: 1;
			padding-bottom: 48px;
			@media screen and (max-width: 1023px) {
				background: $color-primary;
				padding: 48px;
				padding-bottom: 96px;
			}
			@media screen and (max-width: 540px) {
				padding: 24px;
				padding-bottom: 96px;
			}
		}
		&__subheadline {
			@media screen and (max-width: 1279px) {
				font-size: 18px;
			}
			@media screen and (max-width: 767px) {
				font-size: 14px;
			}
		}
		&__headline {
			font-size: 120px;
			@media screen and (max-width: 1279px) {
				font-size: 96px;
			}
			@media screen and (max-width: 767px) {
				font-size: 64px;
			}
		}
		&__arrows-container {
		}
	}
	&.navigation-top {
		min-height: calc(100vh - 100px);
	}
	@media screen and (max-width: 1023px) {
		min-height: calc(100vh - 60px);
		&.navigation-top {
			min-height: calc(100vh - 60px);
		}
	}
}
.c-hero--template-7 {
	min-height: 100vh;
	overflow: hidden;
	background: $main-color;
	color: $main-font-color;
	&.navigation-top {
		min-height: calc(100vh - 100px);
	}
	@media screen and (max-width: 1023px) {
		min-height: calc(100vh - 60px);
		&.navigation-top {
			min-height: calc(100vh - 60px);
		}
	}
	.c-hero {
		&__sponsor {
			max-width: 150px;
			margin: 24px 0 0 0;
			@media screen and (max-width: 767px) {
				order: -1;
				margin: 24px auto 24px auto;
			}
		}
		&__ad {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			@media screen and (max-width: 767px) {
				position: relative;
			}
		}
		&__date {
			@media screen and (max-width: 767px) {
				order: -2;
			}
		}
		&__mobile {
			position: absolute;
			top: 65%;
			width: 100%;
			left: 0;
			padding: 0 24px !important;
			text-align: left;
		}
		&__headline {
			margin-right: -30%;
			font-size: 120px;
			line-height: 1.4;
			color: $main-font-color;
			width: 130%;
			@media screen and (max-width: 1280px) {
				font-size: 96px;
			}
			@media screen and (max-width: 1024px) {
				font-size: 78px;
			}
			@media screen and (max-width: 767px) {
				padding: 0 !important;
				width: auto;
				margin: 0;
				font-size: calc(
					96px + (96 - 56) * (100vw - 768px) / (768 - 480)
				);
			}
			span {
				background: $main-color;
			}
		}
		&__content {
			background: $main-color;
			flex: 1 2 50%;
			position: relative;
			z-index: 3;
			@media screen and (max-width: 1280px) {
				width: 50%;
			}
			@media screen and (max-width: 767px) {
				width: 100%;
				flex: 0 0 auto;
				justify-content: center;
				padding: 0 24px 48px 24px;
			}
			&-inside {
				display: flex;
				flex-direction: column;
				justify-content: center;
			}
			&-inside {
				padding-left: 45%;
				@media screen and (max-width: 1920px) {
					padding-left: 29%;
				}
				@media screen and (max-width: 1640px) {
					padding-left: 20%;
				}
				@media screen and (max-width: 1440px) {
					padding-left: 15%;
				}
				@media screen and (max-width: 1280px) {
					padding-left: 48px;
				}
				@media screen and (max-width: 767px) {
					padding: 0;
					text-align: center;
				}
			}
		}
		&__signees {
			flex: 1 1 53.18681318681319%;
			position: relative;
			z-index: 2;
			@media screen and (max-width: 767px) {
				flex: 1 1 auto;
				aspect-ratio: 1;
			}
		}
		&__signee {
			position: relative;
			background-color: $color-primary;
			background-blend-mode: multiply;
			background-position: top center;
			background-size: cover;
			&-details {
				color: $text-on-primary;
				position: absolute;
				bottom: 0;
				left: 0;
				width: 100%;
				padding: 24px;
				z-index: 3;
				font-family: 'Heebo';
			}
			&-name {
			}
			&:before {
				content: '';
				position: absolute;
				bottom: 0;
				left: 0;
				display: block;
				z-index: 1;
				height: 60%;
				width: 100%;
				background: linear-gradient(
						180deg,
						var(--color-primary-rgba1) 0%,
						var(--color-primary-rgba2) 100%
					),
					linear-gradient(
						180deg,
						rgba(0, 0, 0, 0) 0%,
						rgba(0, 0, 0, 0.8) 100%
					);
			}
		}
	}
	.swiper-slide {
		background-position: center;
		background-size: cover;
	}

	.swiper-slide img {
		display: block;
		width: 100%;
	}
}
</style>

<style lang="scss">
.c-hero--template-7 {
	.c-hero__headline {
		font-weight: 900;
		display: flex;
		flex-wrap: wrap;
		> span {
			display: block;
			padding: 0 24px 0 0;
			&.space {
				display: none;
			}
			background: $main-color;
			@media screen and (max-width: 768px) {
				padding: 0 12px;
			}
			@media screen and (max-width: 768px) {
				padding: 0 6px;
			}
		}
	}
	.c-hero__subheadline {
		> span {
			padding: 12px 4px;
			line-height: 2.4;
			&.space {
				display: none;
				padding: 6px 0px;
			}
			background: $main-color;
		}
	}
}
[data-theme='dark'],
.dark {
	.c-hero--template-1 {
		background: $main-gray-color;
		.c-hero {
			&__date {
				background: $main-gray-color;
			}
			&__right {
				background: $main-gray-color;
			}
			&__details--cursive-x {
				svg {
					fill: #000 !important;
				}
			}
		}
		@media screen and (max-width: 1279px) {
			&::before {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				content: '';
				background: $main-gray-color;
			}
			&__right {
				background: none;
			}
			&__date {
				background: none;
			}
		}
	}
	.c-hero--template-5 {
		.c-hero {
			&__content {
				background: rgba(0, 0, 0, 0.45);
				border-radius: 10px;
			}
		}
	}
	.c-hero--template-6 {
		background: #0d0d0d;
		.c-justsigned__arrows {
			background: #111111;
		}
	}
}
.c-hero--template-3,
.c-hero--template-4,
.c-hero--template-5,
.c-hero--template-6,
.c-hero--template-7 {
	.sidearm-ad {
		background: none;
		border: none;
		@media screen and (max-width: 1023px) {
			.dfp-ad {
				margin: 12px;
			}
		}
	}
}
</style>
